import { Injectable, NgZone, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { ToastrService } from 'ngx-toastr';
import { UserState } from './user.state';
import { PermissionsService } from './permissions.service';

@Injectable({
  providedIn: 'root'
})
export class MercerGuard {
  private router = inject(Router);
  private store = inject(Store);
  private ngZone = inject(NgZone);
  private toast = inject(ToastrService);
  private permissionsService = inject(PermissionsService);

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const isDynamicMercerAccessAllowed = this.store.selectSnapshot(UserState?.isDynamicMercerAccessAllowed);

    if (isDynamicMercerAccessAllowed || this.permissionsService.isSuperAdmin()) {
      return true;
    }
    this.toast.error('Not authorized.');
    return this.ngZone.run(() => this.router.navigate(['']));
  }
}
